import { render, staticRenderFns } from "./AdjustStock.vue?vue&type=template&id=56ff55f3&"
import script from "./AdjustStock.vue?vue&type=script&lang=js&"
export * from "./AdjustStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports